// Add keys to this enum which needs to be cleared when user emulation occurs
export enum CacheKeys {
  WorkPackageDrawerValues = 'drawerValues',
  PlanningWorkPackageDrawerValues = 'planningWorkPackageDrawerValues',
  WorkPackageListCursor = 'wpListCursor',
  BlockDrawerValues = 'blockDrawerValues',
  PlanningSelectedForeman = 'planningSelectedForeman',
  PlanningSelectedGeneralForeman = 'planningSelectedGeneralForeman',
  PlanningSelectedSuperintendent = 'planningSelectedSuperintendent',
  BacklogFilter = 'BacklogFilter',
  WorkListDrawerValues = 'workListDrawerValues',
  WorkListSelectionStateValues = 'workListSelectionStateValues',
  PendingApprovalListSelectedState = 'pendingApprovalListSelectedState',
  PendingApprovalListDrawerValues = 'pendingApprovalListDrawerValues',
  PlanningProgressSelectedWeek = 'planningProgressSelectedWeek',
  DashboardSelectedUser = 'dashboardSelectedUser',
  PlanningSelectedTab = 'planningSelectedTab',
  UserListDrawerValues = 'UserListDrawerValues',
  WeldDrawerValues = 'WeldDrawerValues',
  WeldListCursor = 'WeldListCursor',
  SelectedRodRoom = 'SelectedRodRoom',
  RodRequestListDrawerValues = 'RodRequestListDrawerValues',
  WeldDashboardDrawerValues = 'WeldDashboardDrawerValues',
}

export const EMULATED_USER_ID = 'emulate-user-id';
export const USER_PROJECT_ID = 'user-project-id';
